var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCpool(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedCpool0)",
    d: "M12.429 4.5a7.5 7.5 0 0 0 0 15z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.643 8.571a3.429 3.429 0 1 0 3.017 5.058l1.886 1.028a5.572 5.572 0 1 1 0-5.314L15.66 10.37a3.43 3.43 0 0 0-3.017-1.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedCpool1)",
    d: "M12.429 4.5a7.5 7.5 0 0 0 0 15z",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedCpool0",
    x1: 12.429,
    x2: 10.929,
    y1: 4.924,
    y2: 18.861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23B77F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#2857B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#396CC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#5AA3EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#92F5EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedCpool1",
    x1: 12.429,
    x2: 10.929,
    y1: 4.924,
    y2: 18.861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23B77F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#2857B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#396CC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#5AA3EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#92F5EA"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCpool);
export default __webpack_public_path__ + "static/media/cpool.e18217e00f7e270416f796c26b71611c.svg";
export { ForwardRef as ReactComponent };